module.exports = __webpack_public_path__ + "static/media/diversification.06d340eb.svg";